import './mobile-menu.scss'
import { EventBus } from 'js/utility/event-bus.js'

export const component = {
    name: 'mobile-menu',

    data: {
        visible: false
    },

    watch: {
        visible (value) {
            if (value) {
                window.document.body.classList.add('unscrollable')
            } else {
                window.document.body.classList.remove('unscrollable')
            }
        }
    },

    mounted () {
        EventBus.$on('MobileMenu.toggle', () => {
            this.visible = !this.visible
        });
    },

    methods: {
        toggleMobileMenu() {
            EventBus.$emit('MobileMenu.toggle')
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/mobile-menu/mobile-menu.js